/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import { connect } from 'react-redux';
import GrayPanel from "../../components/GrayPanel";
import PowrotDoListyEuslug from "../../components/PowrotDoListyEuslug";
import EmptyFileDownloader from '../../components/EmptyFileDownloader';
import { DecisionContainer, PersonalDataContainer } from "../../containers";
import history from "../../core/history";
import { runService } from '../../actions/eservices';
import CustomizedMap from "./CustomizedMap";
import pans from "./panStyle.scss";
import ModalAlert from './ModalAlert';
import _ from 'lodash';

import v from './validators';
import { ButtonGroup } from "react-bootstrap";
import { ListaUrzedow } from "../urzad/ListaUrzedow";

const btnStyle = {
  borderRadius: 0,
  border: "none",
  padding: "10px 40px",
  marginLeft: "10px"
};

const AddressFormDict = {
  AddressCity: {
    label: "Miejscowość",
    editable: true
  },
  AddressStreet: {
    label: "Ulica",
    editable: true
  },
  AddressFlat: {
    label: "Numer lokalu",
    editable: true,
    type: "number"
  },
  AddressNumber: {
    label: "Numer budynku",
    editable: true
  },
  AddressZipCode: {
    label: "Kod pocztowy",
    editable: true
  }
};

const AddressFormDict2 = {
  AddressCity: {
    label: 'Miejscowość',
    editable: true,
  },
  cel: {
    label: 'Zaświadczenie niezbędne jest w celu',
    editable: true,
    type: 'textarea',
  },
};

class ZaswiadczenieEMUIA extends React.Component {
  state = {
    AddressFormDict: {
      AddressCity: null,
      AddressStreet: null,
      AddressFlat: null,
      AddressNumber: null,
      AddressZipCode: null,
      cel: null,
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
  };

  validators = {
    AddressCity: [v.NotNull],
    AddressStreet: [v.NotNull],
    AddressNumber: [v.NotNull],
    AddressZipCode: [v.NotNull],
    cel: [],
  }

  nextStep = `/eservices/eserviceSummary/`;

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });

    if (this.props.prefix === 'gmina_olesno_powiat_oleski') {
      this.validators.AddressCity = [v.NotNull];
      this.validators.AddressStreet = [];
      this.validators.AddressFlat = [];
      this.validators.AddressNumber = [];
      this.validators.AddressZipCode = [];
      this.validators.cel = [v.NotNull];
    }
  }

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) =>
    this.setState({ selectedParcels: parcels });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState({
      [group]: {
        ...this.state[group],
        [name]: e.target.value,
      }
    }, () => this.validate(group, name));
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (let validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  }

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          }
        };
      }
    } else {
      const fields = Object.keys(this.state[group]);
      const errors = {};
      for (let f of fields) {
        const checks = this.validateField(group, f);
        errors[f] = checks;
      }
      newState = { errors: errors };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  }

  haseErrors = () => {
    for (let key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  }

  insertTestData = () => this.setState({
    AddressFormDict: {
      AddressCity: 'Pielgrzymka',
      AddressStreet: 'nowogrodzka',
      AddressFlat: 8,
      AddressNumber: 5,
      AddressZipCode: '02-787',
      cel: 'cel testowy',
    },
  })

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: "Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki",
        errorTitle: "Błędnie wypełniony formularz",
        showError: true,
      });
      return;
    }
    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true
      });
      return;
    }
    
    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props.runService(
        this.props.serviceInfo.eservice.shortName,
        this.props.district,
        {
          AddressFormDict: { ...this.state.AddressFormDict },
          selectedParcels: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          urzad: this.props.districts[this.props.prefix]
        },
      ).then(resp => {
        window.location.href = `${this.nextStep}${resp.jobId}`;
      });
    }
  }

  startService = () => {
    this.validate("AddressFormDict", null, this.postValidation);
  };

  render() {
    return (
      <div style={{ paddingTop: "20px" }}>
        <h3 style={{ textAlign: "center" }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />

        <GrayPanel
          title={'1. Teren'}
        >
          <div className="help-desc">
            W celu wybrania przedmiotowej działki lub działek ewidencyjnych należy wykorzystać jeden
            z dwóch dostępnych sposobów wyboru działki:<br />
            <ol>
              <li>
                {' '}
                Wybrać obręb ewidencyjny z rozwijalnej listy obrębów, a następnie wpisać numer
                działki. W celu dodania kolejnej działki należy powtórzyć czynność.
              </li>
              <li>
                Wskazać działkę w oknie mapy wykorzystując przycisk{' '}
                <samp>"Wskaż działki na mapie"</samp>. W celu wybrania kilku działek konieczne jest
                przytrzymanie na klawiaturze klawisza <kbd>CTRL</kbd>.
              </li>
            </ol>
            Wybór działek można usunąć pojedynczo lub usuwając wszystkie za pomocą przycisku{' '}
            <samp>"Odznacz wszystko"</samp>.
          </div>
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </GrayPanel>

        {this.props.prefix === 'gmina_olesno_powiat_oleski' ?
          <DecisionContainer
            title={'2. Informacje'}
            data={this.state.AddressFormDict}
            errors={this.state.errors}
            formDict={AddressFormDict2}
            onChange={e => this.onChange(e, 'AddressFormDict')}
          /> :
          <DecisionContainer
            title={'2. Informacje'}
            data={this.state.AddressFormDict}
            errors={this.state.errors}
            formDict={AddressFormDict}
            onChange={e => this.onChange(e, 'AddressFormDict')}
          />
        }

        <GrayPanel title={"Podstawa prawna:"}>
          <p style={{ textAlign: "justify" }}>
            Zgodnie z załącznikiem do Ustawy z dnia 16 listopada 2006 r. o
            opłacie skarbowej (j.t. Dz. U. z 2016, poz. 1827 z późn. zm.) za
            pozostałe świadczenia pobierana jest opłata skarbowa w wysokości 17
            zł.
          </p>
        </GrayPanel>

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={
                this.props.isDisabled
                  ? "btn btn-primary disabled"
                  : "btn btn-primary"
              }
              style={{ float: "right", marginRight: "15px", ...btnStyle }}
              onClick={() =>
                this.setState({ progress: 0 }, () => this.startService())
              }
            >
              Uruchom
            </button>
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: "right", marginRight: "15px", ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
      </div>
    );
  }
}


ZaswiadczenieEMUIA.contextTypes = {
  fontSizeScale: React.PropTypes.number,
};

const mapState = (state) => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(connect(mapState, mapDispatch)(ZaswiadczenieEMUIA));



// WEBPACK FOOTER //
// src/routes/eservices/ZaswiadczenieEMUIA.js